import Select from 'react-select'

export default Select



// WEBPACK FOOTER //
// ./app/components/Select/index.js